document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.tr-cinema-video');
  if (!sections.length) return;

  sections.forEach((wrapper) => {
    const mainItems = wrapper.querySelectorAll('[data-cinema-main-item]');
    const thumbs = wrapper.querySelectorAll('[data-cinema-thumb]');
    const playButtons = wrapper.querySelectorAll('[data-cinema-play]');
    const strip = wrapper.querySelector('[data-cinema-strip]');

    if (!mainItems.length || !thumbs.length) return;

    let currentIndex = 0;
    let currentVideo = null;

    const setActive = (index) => {
      if (index < 0 || index >= mainItems.length) return;

      // Pause existing video
      if (currentVideo) {
        currentVideo.pause();
      }

      mainItems.forEach((item, i) => {
        const isActive = i === index;
        item.classList.toggle('is-active', isActive);

        if (isActive) {
          const video = item.querySelector('video');
          const overlay = item.querySelector('[data-cinema-play-overlay]');
          if (video) {
            currentVideo = video;
            video.currentTime = 0;
          }
          if (overlay) {
            overlay.classList.remove('is-hidden');
          }
        }
      });

      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === index);
      });

      currentIndex = index;
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = Number(thumb.getAttribute('data-video-index') || '0');
        setActive(index);
      });
    });

    playButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const item = button.closest('[data-cinema-main-item]');
        if (!item) return;

        const video = item.querySelector('video');
        const overlay = item.querySelector('[data-cinema-play-overlay]');
        if (!video) return;

        if (video.paused) {
          // Pause any other playing video
          if (currentVideo && currentVideo !== video) {
            currentVideo.pause();
          }
          video.play();
          currentVideo = video;
          if (overlay) overlay.classList.add('is-hidden');
        } else {
          video.pause();
          if (overlay) overlay.classList.remove('is-hidden');
        }

        video.addEventListener('ended', () => {
          if (overlay) overlay.classList.remove('is-hidden');
          if (currentVideo === video) currentVideo = null;
        });
      });
    });

    // Show main video info only when hovering over the strip
    if (strip) {
      strip.addEventListener('mouseenter', () => {
        wrapper.classList.add('tr-cinema-video--show-info');
      });
      strip.addEventListener('mouseleave', () => {
        wrapper.classList.remove('tr-cinema-video--show-info');
      });
    }

    // Initialize
    setActive(0);
  });
});


